<template>
  <div class="hoveredItem">
    <div v-if="message.isGroup" class="container mr-auto" style="padding:5px;font-size:14px;margin-left: 15px;">
      <div class="leftItem">
        {{ FromName }} -> {{ groupNameTo }}
      </div>
      <div>
        {{ dateEdited }}
      </div>
      <div class="">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 21" width="10"
             height="21"
        >
          <path fill="#9DA3A5" d="M1 15.75l5.2-5.2L1 5.35l1.5-1.5 6.5 6.7-6.6 6.6-1.4-1.4z" />
        </svg>
      </div>
    </div>
    <div v-else class="container mr-auto" style="padding:5px;font-size:14px;margin-left: 15px;">
      <div class="leftItem">
        {{ FromName }} -> {{ ToName }}
      </div>
      <div>
        {{ dateEdited }}
      </div>
      <div>
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 21" width="10"
             height="21"
        >
          <path fill="#9DA3A5" d="M1 15.75l5.2-5.2L1 5.35l1.5-1.5 6.5 6.7-6.6 6.6-1.4-1.4z" />
        </svg>
      </div>
    </div>
    <DeletedMessageBalloon v-if="isDeletedMessage" :message="message" :index="index" />

    <div v-else>
      <TextMessageBalloon v-if="dem.MessageType === 0" :message="dem" :index="index" style="padding:5px;" />
      <ImageMessageBalloon v-else-if="dem.MessageType === 1" :message="dem" :index="index" style="padding:5px;" />
      <VideoMessageBalloon v-else-if="dem.MessageType === 2" :message="dem" :index="index" style="padding:5px;" />
      <LocationMessageBalloon v-else-if="dem.MessageType == 4" :message="dem" :index="index" style="padding:5px;" />
      <ContactMessageBalloon v-else-if="dem.MessageType === 6" :message="dem" :index="index" style="padding:5px;" />
      <InfoMessageBalloon v-else-if="dem.MessageType === 7" :message="dem" :index="index" style="padding:5px;" />
      <AuidoMessageBalloon v-else-if="dem.MessageType === 8" :message="dem" :index="index" style="padding:5px;" />
      <DateMessageBalloon v-else-if="dem.MessageType === 99" :message="dem" :index="index" style="padding:5px;" />
      <DocumentMessageBalloon v-else-if="dem.MessageType === 100" :message="dem" :index="index" style="padding:5px;" />
      <div class="unknownType" v-else>
        {{ message }}
      </div>
    </div>
    <div class="fa fa-chevron-right" />
  </div>
</template>

<script>
import DeletedMessageBalloon from '../../rightcolumn/messages/messageTypes/DeletedMessageBalloon.vue'
import TextMessageBalloon from '../../rightcolumn/messages/messageTypes/TextMessageBalloon.vue'
import ImageMessageBalloon from '../../rightcolumn/messages/messageTypes/ImageMessageBalloon.vue'
import VideoMessageBalloon from '../../rightcolumn/messages/messageTypes/VideoMessageBalloon.vue'
import LocationMessageBalloon from '../../rightcolumn/messages/messageTypes/LocationMessageBalloon.vue'
import ContactMessageBalloon from '../../rightcolumn/messages/messageTypes/ContactMessageBalloon.vue'
import InfoMessageBalloon from '../../rightcolumn/messages/messageTypes/InfoMessageBalloon.vue'
import AuidoMessageBalloon from '../../rightcolumn/messages/messageTypes/AuidoMessageBalloon.vue'
import DateMessageBalloon from '../../rightcolumn/messages/messageTypes/DateMessageBalloon.vue'
import DocumentMessageBalloon from '../../rightcolumn/messages/messageTypes/DocumentMessageBalloon.vue'
import {
  messageMixin
} from '@/mixins/messageMixin.js'
require('@/security.js')

var moment = require('moment')

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mixins: [messageMixin],
  components: {
    DeletedMessageBalloon,
    TextMessageBalloon,
    ImageMessageBalloon,
    VideoMessageBalloon,
    LocationMessageBalloon,
    ContactMessageBalloon,
    InfoMessageBalloon,
    AuidoMessageBalloon,
    DateMessageBalloon,
    DocumentMessageBalloon
  },
  computed: {
    dateEdited () {
      return moment(this.message.CreateDate).format('DD/MM/YYYY')
    },
    groupNameFrom () {
      if (this.message.isGroup) {
        return this.$store.state.group.groups.find(x => x.GroupID === this.message.To).GroupName
      } else {
        return this.getUserNameDisplay(this.message.From)
      }
    },
    groupNameTo () {
      if (this.message.isGroup) {
        return this.$store.state.group.groups.find(x => x.GroupID === this.message.To).GroupName
      } else {
        return this.getUserNameDisplay(this.message.From)
      }
    },
    FromName () {
      return this.getUserNameDisplay(this.message.From)
    },
    ToName () {
      return this.getUserNameDisplay(this.message.To)
    },
    dem () {
      var messageToReturn = {
        ...this.message
      }
      // Reply message decryption
      if (this.message.ReplyMessage) {
        var ReplyMessageObject
        if (typeof (messageToReturn.ReplyMessage) === 'string') {
          ReplyMessageObject = JSON.parse(messageToReturn.ReplyMessage)
        } else {
          ReplyMessageObject = messageToReturn.ReplyMessage
        }

        if (this.$store.state.ien) {
          if (ReplyMessageObject.MessageType !== 7 && ReplyMessageObject.MessageType !== 99) {
            this.dm(ReplyMessageObject)
          }
        }
        messageToReturn.ReplyMessage = ReplyMessageObject
      } else {
        messageToReturn.ReplyMessage = null
      }

      if (!this.message.isLoaded) {
        // Actual message decryption
        if (this.$store.state.ien) {
          if (messageToReturn.MessageType !== 7 && messageToReturn.MessageType !== 99) {
            this.dm(messageToReturn)
          }
        }
        return messageToReturn
      } else if (messageToReturn.MessageType === 7 || messageToReturn.MessageType === 99) {
        return messageToReturn
      } else {
        var defaultMessage = {}
        defaultMessage.From = messageToReturn.From
        defaultMessage.ConversationID = messageToReturn.ConversationID
        defaultMessage.MessageType = 0
        defaultMessage.Body = ''
        defaultMessage.CreateDate = messageToReturn.CreateDate
        return defaultMessage
      }
    },
    isDeletedMessage () {
      // let messageDate = moment(this.message.UpdateDate)
      // let currentDate = moment()
      // let isVisible = moment.duration(currentDate.diff(messageDate)) < 3600000 // Only showing last hour's deleted messages
      return ((this.message.DeleteStatus === 11 && this.message.From === this.$store.state.session.user.UserID) || this.message.Status === 12)
    },
    isExpiredMessage () {
      let messageDate = moment(this.message.UpdateDate)
      let currentDate = moment()
      let isVisible = moment.duration(currentDate.diff(messageDate)) < 3600000 // Only showing last hour's deleted messages
      return ((this.message.DeleteStatus === 11 && this.message.From === this.$store.state.session.user.UserID) || this.message.Status === 12) && !isVisible
    }
  },
  methods: {
    animateMessage () {

    }
  }
}

</script>

<style scoped>
  .unknownType {
    background-color: greenyellow;
    padding: 20px;
    font-size: 12px;
  }
  .container{
      display: flex;
      justify-content: flex-end;
  }
  .hoveredItem{
    background-color: #f3f0f0;
  }
  .hoveredItem:hover{
      background-color: #e4e4e4;
      cursor: pointer;
  }
  .leftItem{
      flex-grow:10;
  }
  .rightItem{

  }

</style>
